﻿import React, { useContext, useMemo } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { InTime_User } from '@Util/Types';
import Content_Container from '@Elements/Content_Container';
import Team_List from '@Elements/Team_List';

function isEmpty(array: InTime_User[]): boolean {
    return array.length === 0;
}

export default function Team_Module(): JSX.Element {
    const [t] = useTranslation();
    const { intime_users }: context_type = useContext(Context);

    const sorted_team_members_list = useMemo(() => {
        if (!intime_users) return { online: [], offline: [] };

        const working_team_members = intime_users.filter(user => user.current?.customerName !== null);
        const offline_team_members = intime_users.filter(user => user.current?.customerName === null);

        return {
            online: working_team_members,
            offline: offline_team_members
        };
    }, [intime_users]);

    return (
        <section className="Module Team_Module">
            <header className="Module_Header">
                <h2 className="Headline2">{t('Text.Team')}</h2>
            </header>
            <Content_Container>
                <div className="Team">
                    {!isEmpty(sorted_team_members_list.online) && (
                        <div className="Team_Container">
                            <Team_List
                                data={sorted_team_members_list.online}
                                offline={false}
                            />
                        </div>
                    )}
                    {!isEmpty(sorted_team_members_list.offline) && (
                        <div className="Team_Container">
                            <Team_List
                                data={sorted_team_members_list.offline}
                                offline={true}
                            />
                        </div>
                    )}
                </div>
            </Content_Container>
        </section>
    );
}